import React, { useState, useEffect } from 'react';
import CloseCircleIcon from '@nykaa/ui-components/Icons/circle-x-duotone';
import {
  FloatingWrapper,
  QrImage,
  Content,
  Title,
  Subtitle,
  PhoneImageWrapper,
  RightFixedBox,
  CloseButton,
} from './styled';
import {
  QR_APP_BANNER_CLOSE_COUNT,
  QR_APP_BANNER_CLOSED,
  QR_APP_BANNER_LAST_CLOSED,
  QR_APP_BANNER_PHONE_IMAGE_SRC,
} from './constants';

interface QrAppBannerProps {
  qrCodeUrl: string;
  title: string;
  subtitle: string;
  clearStorageTimeout: number;
  closeCountThreshold: number;
}

const daysToMilliseconds = (days: number) => days * 24 * 60 * 60 * 1000;

const QrAppBanner: React.FC<QrAppBannerProps> = ({
  qrCodeUrl,
  title,
  subtitle,
  clearStorageTimeout,
  closeCountThreshold,
}) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!qrCodeUrl) return;

    const lastClosed =
      Number(localStorage.getItem(QR_APP_BANNER_LAST_CLOSED)) || 0;
    const closeCount =
      Number(localStorage.getItem(QR_APP_BANNER_CLOSE_COUNT)) || 0;
    const timeNow = Date.now();
    const thresholdTime = daysToMilliseconds(clearStorageTimeout);
    if (lastClosed && timeNow - lastClosed > thresholdTime) {
      localStorage.removeItem(QR_APP_BANNER_CLOSE_COUNT);
      sessionStorage.removeItem(QR_APP_BANNER_CLOSED);
      setVisible(true);
      return;
    }

    const shouldShow =
      closeCount < closeCountThreshold &&
      sessionStorage.getItem(QR_APP_BANNER_CLOSED) !== '1';

    setVisible(shouldShow);
  }, [qrCodeUrl, clearStorageTimeout, closeCountThreshold]);
  if (!qrCodeUrl) return null;
  const handleClose = () => {
    setVisible(false);
    sessionStorage.setItem(QR_APP_BANNER_CLOSED, '1');
    const closeCount =
      Number(localStorage.getItem(QR_APP_BANNER_CLOSE_COUNT)) || 0;
    localStorage.setItem(QR_APP_BANNER_CLOSE_COUNT, String(closeCount + 1));
    localStorage.setItem(QR_APP_BANNER_LAST_CLOSED, String(Date.now()));
  };

  if (!visible) return null;

  return (
    <FloatingWrapper>
      <QrImage
        src={qrCodeUrl}
        alt="QR code"
      />
      <Content>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Content>
      <PhoneImageWrapper src={QR_APP_BANNER_PHONE_IMAGE_SRC} />
      <RightFixedBox>
        <CloseButton onClick={handleClose}>
          <CloseCircleIcon />
        </CloseButton>
      </RightFixedBox>
    </FloatingWrapper>
  );
};

export default QrAppBanner;
